import { safeDefine } from "../../registration/safe-define.js";
import { TooltipLabelElement } from "../../ui/tooltip/label.js";
//#region src/define/ui/tooltip-label.ts
safeDefine(TooltipLabelElement);
//#endregion

//# sourceMappingURL=tooltip-label.js.map